<template>
  <div class="row iconos">
    <div class="row col-10 mx-auto justify-content-center align-items-center">
      <!-- JORNADA -->
      <Jornada
        :jornada="jornada"
        styleImg="width: 24px;"
        classImg="mr-2"
        classDiv="row ml-0 mr-1"
      />
      <!-- GRATUIDAD -->
      <!--<Gratuidad
        :gratuidad="gratuidad"
        styleImg="max-width: 24px;"
        classImg="mr-3"
        classSvg="ml-2"
        classDiv="row ml-0 mr-3"
      />-->
      <!-- POSTULACIONES -->
      <PostulacionTP
        v-if="postulacion"
        :postulacion="postulacion"
        classDiv="row ml-0"
        classImg="mr-2"
        styleImg="width: 24px;"
      />
      <!--MODALIDAD-->
      <!--<img
        src="@/assets/img/iconos/modo-presencial-1.svg"
        style="max-width: 24px;"
        class="mr-3"
        v-b-tooltip.hover
        title="Modalidad presencial"
        v-if="modalidad === 'PRESENCIAL'"
      />
      -->
    </div>
  </div>
</template>

<script>
import PostulacionTP from "@/components/generales/iconos/PostulacionTP";
import Jornada from "@/components/generales/iconos/Jornada";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
export default {
  name: "Iconos",
  components: {
    PostulacionTP,
    Jornada,
    Gratuidad
  },
  props: {
    jornada: { type: String },
    //modalidad: { type: String },
    //gratuidad: { type: Boolean },
    postulacion: { type: String }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/iconos/IconosTarjeta.vue